import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';

import FavouriteView from 'views/Favourite';
import MediaAudioService from 'api/MediaAudio';
import { useDelete, useFetchTableData } from 'hooks';
import SettingsActions from 'store/reducers/Settings';

const Favourite = ( { parentPath, toggleLoading, toggleErrorAlert, user } ) => {
  const [audioSubmitted, setAudioSubmitted] = useState( new Date().valueOf() );

  const [fetchData, data, dataLoading] = useFetchTableData( {
    promise: MediaAudioService.getMediaAudios,
    toggleErrorAlert,
    deps: [audioSubmitted],
  } );

  const reloadData = useCallback( () => {
    setAudioSubmitted( new Date().valueOf() );
  }, [] );

  const deleteEntity = useDelete( {
    promise: MediaAudioService.deleteMediaAudio,
    callback: reloadData,
    toggleLoading,
    toggleErrorAlert,
  } );

  return (
    <FavouriteView
      data={data}
      parentPath={parentPath}
      isLoading={dataLoading}
      onFetchData={fetchData}
      onDelete={deleteEntity}
      onReloadData={reloadData}
      userData={user}
    />
  );
};

const mapStateToProps = ({ user }) => ({
  user
});

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
  toggleLoading: SettingsActions.toggleLoading,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Favourite );
